export const getLocationIdFromUrl = (givenUrl: string) => {
  const url = new URL(givenUrl);
  const pathArray = url.pathname.split('/');
  return pathArray[pathArray.length - 1];
};
